interface QueueNode<T> {
  key: number;
  value: T;
}

/**
 * @deprecated use `TinyQueue` from `tinyqueue` package instead
 */
export class PriorityQueue<T> {
  private heap: QueueNode<T>[] = [];
  get empty(): boolean {
    return this.length === 0;
  }
  get length(): number {
    return this.heap.length;
  }
  private left(idx: number) {
    return 2 * idx + 1;
  }
  private right(idx: number) {
    return 2 * idx + 2;
  }
  private hasLeft(idx: number): boolean {
    return this.left(idx) < this.length;
  }
  private hasRight(idx: number): boolean {
    return this.right(idx) < this.length;
  }
  private parent(idx: number) {
    return Math.floor((idx - 1) / 2);
  }
  constructor() {}
  swap(a: number, b: number) {
    const tmp = this.heap[a];
    this.heap[a] = this.heap[b];
    this.heap[b] = tmp;
  }
  insert(item: T, priority: number) {
    if (priority === null || priority === undefined) {
      throw new Error("Priority cannot be null");
    }
    if (isNaN(priority)) {
      throw new Error("Priority must be a number");
    }
    this.heap.push({
      key: priority,
      value: item,
    });

    let i = this.length - 1;
    while (i > 0) {
      const p = this.parent(i);
      if (this.heap[p].key < this.heap[i].key) {
        break;
      }
      const tmp = this.heap[i];
      this.heap[i] = this.heap[p];
      this.heap[p] = tmp;
      i = p;
    }
  }
  pop(): T | null {
    if (this.empty) {
      return null;
    }

    this.swap(0, this.length - 1);
    const item = this.heap.pop();

    let curr = 0;
    while (this.hasLeft(curr)) {
      let smaller = this.left(curr);
      if (this.hasRight(curr) && this.heap[this.right(curr)].key < this.heap[this.left(curr)].key) {
        smaller = this.right(curr);
      }

      if (this.heap[smaller].key > this.heap[curr].key) {
        break;
      }

      this.swap(curr, smaller);
      curr = smaller;
    }

    if (item === undefined) {
      return null;
    }

    return item.value;
  }
  peek(): T | null {
    return this.length === 0 ? null : this.heap[0].value;
  }
  all(): T[] {
    return this.heap.map((node) => node.value);
  }
}
